import React from "react"
import { Box, Checkbox, ImageList, ImageListItem } from "@mui/material"

const MAX_THUMBNAIL_COLUMNS = 5

interface Props {
  urls: string[]
  previewIndex: number
  onPreviewChange: (idx: number) => void
  selectedIndices: Set<number>
  onToggle: (idx: number) => void
}

const ImageSelectionList: React.FC<Props> = ({ urls, previewIndex, onPreviewChange, selectedIndices, onToggle }) => {
  if (urls.length === 0) return null

  return (
    <ImageList
      cols={Math.min(urls.length, MAX_THUMBNAIL_COLUMNS)}
      rowHeight={80}
      gap={8}
      sx={{
        m: 0,
        display: "flex",
        flexDirection: "row",
        gap: 1,
        mt: 1.5,
        overflowX: "auto",
        scrollSnapType: "x mandatory",
        pb: 0.5
      }}>
      {urls.map((url, idx) => (
        <ImageListItem
          key={idx}
          onClick={() => onPreviewChange(idx)}
          sx={{
            position: "relative",
            flex: "0 0 auto",
            width: 80,
            height: 80,
            scrollSnapAlign: "start",
            cursor: "pointer",
            borderRadius: 1,
            overflow: "hidden",
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: idx === previewIndex ? "primary.main" : "transparent",
            transition: "outline-color 0.15s, opacity 0.15s",
            "&:hover": { opacity: 0.82 }
          }}>
          <Checkbox
            size="small"
            checked={selectedIndices.has(idx)}
            inputProps={{ "aria-label": `Select image ${idx + 1}` }}
            onClick={e => e.stopPropagation()}
            onChange={() => onToggle(idx)}
            sx={{
              position: "absolute",
              top: 2,
              left: 2,
              zIndex: 1,
              bgcolor: "rgba(255,255,255,0.75)",
              p: 0.25,
              borderRadius: 0.5
            }}
          />
          <Box
            component="img"
            src={url}
            alt={`Thumbnail ${idx + 1}`}
            sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
        </ImageListItem>
      ))}
    </ImageList>
  )
}

export default ImageSelectionList
